class Particle {

  constructor(x, y, radius) {
    this.x = x;
    this.y = y;

    this.radius = radius;

    this.vx = 1.2;
    this.vy = 0.8;

    this.baseSpeed = Math.sqrt(
  this.vx * this.vx +
  this.vy * this.vy
);

this.angle = Math.random() * Math.PI * 2;

this.rotationSpeed =
  (Math.random() - 0.5) * 0.03;

this.scale = 1;

  }

  update(width, height) {


    this.applyFriction();

this.maintainSpeed();

this.bounce(width, height);

this.move();

this.angle += this.rotationSpeed;

}

applyFriction() {

  this.vx *= 0.96;
  this.vy *= 0.96;

}

bounce(width, height) {

  if (this.x < this.radius || this.x > width - this.radius) {
    this.vx *= -1;
  }

  if (this.y < this.radius || this.y > height - this.radius) {
    this.vy *= -1;
  }

}

maintainSpeed() {

  const speed = Math.sqrt(
    this.vx * this.vx +
    this.vy * this.vy
  );

  if (speed > 0 && speed < this.baseSpeed) {

    const scale = this.baseSpeed / speed;

    this.vx *= scale;
    this.vy *= scale;

  }

}

move() {

  this.x += this.vx;
  this.y += this.vy;

}


  

  applyForce(forceX, forceY) {

  this.vx += forceX;
  this.vy += forceY;

}


}




class RepulseEffect {

  apply(particle, mouse) {

    const dx = particle.x - mouse.x;
    const dy = particle.y - mouse.y;

    const distance = Math.sqrt(dx * dx + dy * dy);

    if (
      distance < mouse.repulseRadius &&
      distance > 0
    ) {

      const force =
        ((mouse.repulseRadius - distance) /
          mouse.repulseRadius) *
        mouse.repulseStrength;

      particle.applyForce(
        (dx / distance) * force,
        (dy / distance) * force
      );

    }

  }

}

class WindEffect {

  apply(particle) {

    particle.applyForce(
      this.config.windForceX,
      this.config.windForceY
    );

  }

}

class DriftEffect {

  apply(particle) {

    const driftStrength = 0.003;

    particle.applyForce(
      (Math.random() - 0.5) * driftStrength,
      (Math.random() - 0.5) * driftStrength
    );

  }

}

class SeparationEffect {

  apply(particle) {

    const particles = this.particles;

    if (!particles) return;

    const separationDistance = 60;
    const separationStrength = 0.015;

    for (const other of particles) {

      if (other === particle) continue;

      const dx = particle.x - other.x;
      const dy = particle.y - other.y;

      const distance = Math.sqrt(
        dx * dx + dy * dy
      );

      if (
        distance > 0 &&
        distance < separationDistance
      ) {

        const force =
          (1 - distance / separationDistance) *
          separationStrength;

        particle.applyForce(
          (dx / distance) * force,
          (dy / distance) * force
        );

      }

    }

  }

}
  


class CircleRenderer {

  begin(ctx) {

    // No setup needed for circles

  }

  draw(ctx, particle) {

    ctx.beginPath();

    ctx.arc(
      particle.x,
      particle.y,
      particle.radius,
      0,
      Math.PI * 2
    );

    ctx.fillStyle = "#1d8be6";

    ctx.fill();

  }

  end(ctx) {

    // No cleanup needed

  }

}

class SquareRenderer {

  begin(ctx) {

    // No setup needed

  }

  draw(ctx, particle) {

    const size = particle.radius * 2;

    ctx.fillStyle = "#1d8be6";

    ctx.fillRect(
      particle.x - particle.radius,
      particle.y - particle.radius,
      size,
      size
    );

  }

  end(ctx) {

    // No cleanup needed

  }

}

class GlowRenderer {

  begin(ctx) {

    ctx.save();

    ctx.shadowBlur = 20;
    ctx.shadowColor = "#1d8be6";

  }

  draw(ctx, particle) {

    ctx.beginPath();

    ctx.arc(
      particle.x,
      particle.y,
      particle.radius,
      0,
      Math.PI * 2
    );

    ctx.fillStyle = "#1d8be6";

    ctx.fill();

  }

  end(ctx) {

    ctx.restore();

  }

}

class ImageRenderer {

  constructor(image) {

    this.image = image;

  }

  begin(ctx) {

  }

  draw(ctx, particle) {

  if (!this.image) return;

  const size = particle.radius * 4;

  ctx.save();

  ctx.translate(
    particle.x,
    particle.y
  );

  ctx.rotate(
    particle.angle
  );

  ctx.drawImage(
    this.image,
    -size / 2,
    -size / 2,
    size,
    size
  );

  ctx.restore();

}

  end(ctx) {

  }

}

class RendererFactory {

  static create(type, image = null) {

    switch (type) {

      case "circle":
        return new CircleRenderer();

      case "square":
        return new SquareRenderer();

      case "glow":
        return new GlowRenderer();

      case "image":
        return new ImageRenderer(image);

      default:
        return new GlowRenderer();

    }

  }

}

class ParticleManager {

  constructor(config, canvas) {

  this.config = config;
  this.canvas = canvas;
  this.particles = [];

  this.create();

}

  create() {

    this.particles = [];

    for (let i = 0; i < this.config.particleCount; i++) {

      this.particles.push(

        new Particle(

          Math.random() * this.canvas.width,
          Math.random() * this.canvas.height,

          this.config.minRadius +

          Math.random() *

          (this.config.maxRadius - this.config.minRadius)

        )

      );

    }

  }

  update(width, height, effectManager, mouse) {

    for (const particle of this.particles) {

      effectManager.apply(
  particle,
  mouse
);

      particle.update(
        width,
        height
      );

    }

  }

  draw(ctx, renderer) {

  renderer.begin(ctx);

  for (const particle of this.particles) {

    renderer.draw(
      ctx,
      particle
    );

  }

  renderer.end(ctx);

}

}

class EngineConfig {

  static fromDataset(dataset) {

  return new EngineConfig({

    particleCount:
  dataset.particleCount != null
    ? Number(dataset.particleCount)
    : 20,

    minRadius:
      Number(dataset.minRadius) || 5,

    maxRadius:
      Number(dataset.maxRadius) || 11,

    linkDistance:
      Number(dataset.linkDistance) || 120,

    repulseRadius:
      Number(dataset.repulseRadius) || 150,

    repulseStrength:
      Number(dataset.repulseStrength) || 2,

    windForceX:
  dataset.windForceX !== undefined
    ? Number(dataset.windForceX) / 1000
    : 0.015,

windForceY:
  dataset.windForceY !== undefined
    ? Number(dataset.windForceY) / 1000
    : 0,

  });

}

  constructor(options = {}) {

  this.particleCount =
    options.particleCount ?? 20;

  this.minRadius =
    options.minRadius ?? 5;

  this.maxRadius =
    options.maxRadius ?? 11;

  this.linkDistance =
    options.linkDistance ?? 120;

  this.repulseRadius =
    options.repulseRadius ?? 150;

  this.repulseStrength =
    options.repulseStrength ?? 2;

  this.windForceX =
    options.windForceX ?? 0.015;

  this.windForceY =
    options.windForceY ?? 0;

    

}

}

class EffectManager {

  constructor(config) {

    this.config = config;
    this.effects = [];

  }

  add(effect) {

    effect.config = this.config;

    this.effects.push(effect);

  }

  apply(particle, mouse) {

    for (const effect of this.effects) {

      effect.apply(
        particle,
        mouse
      );

    }

  }

}


class AssetManager {

  constructor() {

    this.assets = new Map();

  }

  register(name, asset) {

    this.assets.set(
      name,
      asset
    );

  }

  get(name) {

    return this.assets.get(name);

  }

  has(name) {

    return this.assets.has(name);

  }

  async loadImage(name, url) {

    if (this.has(name)) {

      return this.get(name);

    }

    return new Promise((resolve, reject) => {

      const image = new Image();

      image.onload = () => {

        this.register(
          name,
          image
        );

        resolve(image);

      };

      image.onerror = reject;

      image.src = url;

    });

  }

}

class BackgroundEffects {

  constructor(canvas) {

  this.canvas = canvas;
  this.ctx = canvas.getContext("2d");

  this.initialize();

}


  initialize() {

  this.initializeRenderer();

  this.config =
    EngineConfig.fromDataset(
      this.canvas.dataset
    );

  this.assetManager = new AssetManager();

  this.resize();

  this.section = this.canvas.closest("section");

  this.initializeMouse();

  this.initializeParticles();

  this.initializeEffects();

  this.initializeEvents();

  this.draw();

}

initializeMouse() {

  this.mouse = {
    x: -1000,
    y: -1000
  };

  this.section.addEventListener("mousemove", (event) => {

    const rect = this.canvas.getBoundingClientRect();

    this.mouse.x = event.clientX - rect.left;
    this.mouse.y = event.clientY - rect.top;

  });

  this.section.addEventListener("mouseleave", () => {

    this.mouse.x = -1000;
    this.mouse.y = -1000;

  });

}

initializeRenderer() {

  this.renderer =
  RendererFactory.create("glow");

  this.particleImageUrl =
    this.canvas.dataset.particleImage || "";

  this.particleImage = null;

  if (!this.particleImageUrl) {
    return;
  }

  this.particleImage = new Image();

  this.particleImage.src =
    this.particleImageUrl;

  this.particleImage.onload = () => {

  console.log("Particle image loaded.");

  this.renderer =
    RendererFactory.create(
      "image",
      this.particleImage
    );

  };

}

initializeEffects() {

  this.effectManager = new EffectManager(
    this.config
  );

  // Gentle organic movement
  this.effectManager.add(
    new DriftEffect()
  );

  // Mouse interaction
  this.effectManager.add(
    new RepulseEffect()
  );

  // Keeps particles from clustering
  const separationEffect =
    new SeparationEffect();

  separationEffect.particles =
    this.manager.particles;

  this.effectManager.add(
    separationEffect
  );

}


initializeParticles() {

  this.manager = new ParticleManager(
    this.config,
    this.canvas
  );

}

initializeEvents() {

  this.resizeHandler = () => this.resize();

  window.addEventListener(
    "resize",
    this.resizeHandler
  );

}

  resize() {
    const rect = this.canvas.parentElement.getBoundingClientRect();

    this.canvas.width = rect.width;
    this.canvas.height = rect.height;
  }
  
  drawLinks() {

  const maxDistance = this.config.linkDistance;

  for (let i = 0; i < this.manager.particles.length; i++) {

    for (let j = i + 1; j < this.manager.particles.length; j++) {

      const a = this.manager.particles[i];
      const b = this.manager.particles[j];

      const dx = a.x - b.x;
      const dy = a.y - b.y;

      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance < maxDistance) {

        const opacity = 1 - distance / maxDistance;

        this.ctx.beginPath();
        this.ctx.moveTo(a.x, a.y);
        this.ctx.lineTo(b.x, b.y);

        this.ctx.strokeStyle = `rgba(29, 139, 230, ${opacity})`;
        this.ctx.lineWidth = 1;
        this.ctx.stroke();

      }

    }

  }

}

 draw() {

  this.ctx.clearRect(
    0,
    0,
    this.canvas.width,
    this.canvas.height
  );

  this.manager.update(
    this.canvas.width,
    this.canvas.height,
    this.effectManager,
    {
      x: this.mouse.x,
      y: this.mouse.y,
      repulseRadius: this.config.repulseRadius,
      repulseStrength: this.config.repulseStrength
    }
  );

  this.manager.draw(
    this.ctx,
    this.renderer
  );

  this.drawLinks();

  if (this.destroyed) return;

  this.animationFrame =
    requestAnimationFrame(() => this.draw());

}

destroy() {

  this.destroyed = true;

  if (this.animationFrame) {
    cancelAnimationFrame(this.animationFrame);
  }

  window.removeEventListener(
    "resize",
    this.resizeHandler
  );

}

}

const backgroundInstances = new WeakMap();

function initializeBackgroundEffects(root = document) {

  root
    .querySelectorAll(".background-effects-canvas")
    .forEach(canvas => {

      if (backgroundInstances.has(canvas)) {
        backgroundInstances.get(canvas).destroy();
      }

      const instance = new BackgroundEffects(canvas);

      backgroundInstances.set(canvas, instance);

    });

}

document.addEventListener("DOMContentLoaded", () => {
  initializeBackgroundEffects();
});

document.addEventListener("shopify:section:load", (event) => {
  initializeBackgroundEffects(event.target);
});

document.addEventListener("shopify:section:unload", (event) => {

  event.target
    .querySelectorAll(".background-effects-canvas")
    .forEach(canvas => {

      if (backgroundInstances.has(canvas)) {
        backgroundInstances.get(canvas).destroy();
        backgroundInstances.delete(canvas);
      }

    });

});